import React from 'react';
import TopBar from './TopBar';

const Header = (props) => {
  return <TopBar {...props} />;
};

export default Header;
